import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helper from '../../helpers/Helper';
import * as styles from './style';
import withCreateUhuuMenu from '../../containers/CreateUhuuMenu';
import { SALE_TYPES } from '../../helpers/constants';

const EventListItem = ({ data, selectRepetition, toggleAll, saleType }) => {
  const { repetitions, local } = data;
  const isAllChecked = () => {
    return data.repetitions.every(rep => rep.checked);
  };

  const isSomeChecked = () => {
    return data.repetitions.some(rep => rep.checked);
  };
  return (
    <Fragment>
      <styles.SubItem id={`exhibition-${data.id}`}>
        <styles.Checkbox
          checked={isAllChecked()}
          someChecked={isSomeChecked()}
          id={`exhibition-check-${data.id}`}
          disabled={data.disabled}
          onClick={!data.disabled ? () => toggleAll(data.id) : null}
        />
        <styles.SubTitle>{local.name}</styles.SubTitle>
      </styles.SubItem>
      <styles.Content>
        <styles.Repetitions>
          {saleType === SALE_TYPES.defaultMenu
            ? null
            : repetitions.map(rep => (
                <styles.RepItem key={rep.id}>
                  <styles.Checkbox
                    id={`check-rep-${rep.id}`}
                    name={`check-rep-${rep.id}`}
                    checked={rep.checked}
                    disabled={rep.disabled}
                    onClick={
                      !rep.disabled
                        ? () => selectRepetition({ exibithionId: data.id, repetitionId: rep.id })
                        : null
                    }
                    customStyles={{ paddingLeft: 0 }}
                  />
                  <styles.RepDate>
                    {Helper.formatDate(new Date(Helper.formatStringDate(rep.exhibitionDate)))}
                  </styles.RepDate>
                </styles.RepItem>
              ))}
        </styles.Repetitions>
      </styles.Content>
    </Fragment>
  );
};

EventListItem.propTypes = {
  data: PropTypes.object,
  selectRepetition: PropTypes.func,
  toggleAll: PropTypes.func,
};

export default withCreateUhuuMenu(EventListItem);



// WEBPACK FOOTER //
// ./src/components/EventListItem/index.js